import { toast } from 'vue-sonner';
import FileSheet from '@/components/sheets/FileSheet.vue';
import useApi from '@/composables/useApi.ts';
import useSheet from '@/composables/useSheet.ts';
import type { File } from '@/types/api';

export default function useFile(fileUid?: string) {
    const useFetch = useApi();
    const sheet = useSheet();

    async function view(uidOrEvent?: string | Event) {
        const uid = typeof uidOrEvent === 'string' ? uidOrEvent : fileUid;

        if (!uid) {
            throw Error(
                'Missing required parameter uid. Please pass it to the view function or useFile composable.'
            );
        }

        const { data, error } = await useFetch<File>('file/' + uid);

        if (error.value) {
            console.error(error.value);
            toast.error('Datei konnte nicht geöffnet werden.');
            return;
        }

        await sheet.start({
            title: 'Dokumentinformation',
            class: '2xl:w-140',
            component: FileSheet,
            props: {
                file: data.value,
            },
        });
    }

    return {
        view,
    };
}
